import Cookie from 'js-cookie'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

interface VisistorOptions {
  axios: AxiosInstance
  prefix?: string | null
  domain?: string
  attachToken: boolean
}

export class Visitor {
  protected options: VisistorOptions

  constructor(options: VisistorOptions) {
    this.options = options
  }

  setOptions(options: { axios?: AxiosInstance; prefix?: string | null; domain?: string; attachToken?: boolean }) {
    this.options = Object.assign(this.options, options)
  }

  async visit<T>(config: AxiosRequestConfig): Promise<T> {
    const token = Cookie.get('accessToken')
    const { axios, domain, prefix, attachToken } = this.options
    const root = prefix ? domain + '/' + prefix : domain

    //for external links
    if (!config.url!.startsWith('http')) {
      config.url = root + '/' + config.url
    }

    if (!config.headers) {
      config.headers = {}
    }

    if (attachToken && token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    const response = await axios(config)

    return response.data as T
  }
}

export const visitor = new Visitor({
  axios,
  prefix: null,
  domain: 'https://api.rhitics.com',
  attachToken: true
})
export type visitInterface = <T>(config: AxiosRequestConfig) => Promise<T>
export const visit: visitInterface = visitor.visit.bind(visitor)

export const toolVisitor = new Visitor({
  axios,
  prefix: 'api',
  domain: 'https://tool.rhitics.com',
  attachToken: false
})
export const toolVisit: visitInterface = toolVisitor.visit.bind(toolVisitor)
